import { createContext, useContext } from 'react';

export interface EditorActions {
  saving: boolean;
  lastSaved: Date | null;
  save: () => Promise<void>;
  rendering: boolean;
  render: () => Promise<void>;
  renderError: string | null;
  staticMode: boolean;
}

const EditorActionsContext = createContext<EditorActions>({
  saving: false,
  lastSaved: null,
  save: async () => {},
  rendering: false,
  render: async () => {},
  renderError: null,
  staticMode: false,
});

export const EditorActionsProvider = EditorActionsContext.Provider;
export const useEditorActions = () => useContext(EditorActionsContext);
